import React, { useEffect } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import { Col, Container, Row } from 'react-bootstrap'
import PrivacyContainer from '../components/PrivacyContainer/PrivacyContainer'
import Footer from '../components/Footer/Footer'
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux'

function Privacy() {
  const { pathname } = useLocation();
  const layout = useSelector((state) => state.layoutRducer.layoutArray);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);


  return (
    <div style={{
      display:"flex",
          flexDirection: "column",
    justifyContent: "space-between",
    height:" 100vh",
    }}>
            <NavbarContainer />
      <Container>
        <Row>

          <Col md={12}>
            <PrivacyContainer layout={layout} />

          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  )
}

export default Privacy